import { type ActivitiesRecord, type TimesRecord, pb } from "@/utils/PocketBaseAdapter";
import { defineStore } from "pinia";
import { useUserStore } from "./UserStore";

export const useActivityStore = defineStore("ActivityStore", () => {
  const timesList = ref<TimesRecord[]>([]);

  // stores
  const userStore = useUserStore();
  const { currentLocation } = storeToRefs(userStore);
  const activitiesMap = ref<Map<string | undefined, string>>(new Map());

  // Actions
  const getActivityList = async (params: any) => {
    let filters = "";

    if (params.location) {
      if (filters) filters += `&&location="${params?.location}"`;
      else filters = `location="${params?.location}"`;
    }

    if (params.q) {
      if (filters) filters += `&&name ~ "${params.q}"`;
      else filters = `name ~ "${params.q}"`;
    }

    let sortParam = "sortOrder";
    if (params?.sortBy.length) {
      sortParam =
        params?.sortBy[0].order === "desc"
          ? `-${params?.sortBy[0].key}`
          : params?.sortBy[0].key;
    }

    // fetch a paginated records list
    return await pb
      .collection("activities")
      .getList<ActivitiesRecord>(params.page, params.itemsPerPage, {
        filter: filters,
        sort: sortParam ? sortParam : "",
      });
  };

  const getTimeList = async (filter: string | undefined) => {
    try {
      // Fetch all records at once via getFullList
      const records = await pb.collection("times").getFullList<TimesRecord>();

      // Filter timesList on current Location
      const filteredRecords = records.filter((record) => {
        return record.location === filter;
      });

      timesList.value = filteredRecords;

      return filteredRecords;
    } catch (error) {}
  };

  const getActivitiesMap = async () => {
    try {
      // Fetch all records
      const records = await pb.collection("activities").getFullList({
        sort: "-created",
      });

      // Populate the Map with 'id' as key and 'name' as value
      activitiesMap.value = records.reduce((map, record) => {
        map.set(record.id, record.name);
        return map;
      }, new Map<string, string>());
    } catch (error) {
      console.log("Error getting activities: ", error);
    }
  };

  return {
    timesList,
    activitiesMap,
    getActivityList,
    getTimeList,
    getActivitiesMap,
  };
});
